import { Component } from "@angular/core";





@Component({
    selector: 'app-courtesy-home',
    templateUrl: './courtesy-home.component.html',
    styleUrls: ['./courtesy-home.component.scss']
  })


  export class CourtesyhomeComponent {


  }  